import { motion } from "framer-motion";
import { Phone, MapPin, MessageCircle, ShoppingBag } from "lucide-react";
import { CONTACT } from "../../data/site";
import { useCart } from "../../context/CartContext";

const waLink = `https://wa.me/${CONTACT.phoneRaw}?text=${encodeURIComponent(
  "Hi Mamta! I'd like to order some pickles from Mamta's Kitchen."
)}`;

export const OrderSection = () => {
  const { setDrawerOpen, count } = useCart();
  return (
    <section id="order" className="bg-[#F9F6F0] py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="rounded-md bg-[#1E1A17] text-[#F9F6F0] overflow-hidden grid grid-cols-1 lg:grid-cols-2">
          <div className="p-8 md:p-14">
            <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#E28721] font-semibold mb-4">Order Online</p>
            <h2 className="font-serif text-4xl sm:text-5xl leading-none tracking-tight">
              Two easy ways to get your jars.
            </h2>
            <p className="text-[#B4A79A] text-base md:text-lg mt-6 leading-relaxed max-w-md">
              Add jars to your basket and place an order in seconds — or message Mamta directly on WhatsApp. We confirm
              every order personally and deliver across Delhi NCR.
            </p>

            <div className="mt-9 flex flex-col sm:flex-row gap-4">
              <button
                data-testid="order-open-basket"
                onClick={() => setDrawerOpen(true)}
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#B83A14] hover:bg-[#942B0D] text-white px-7 py-3.5 text-sm tracking-wide transition-colors"
              >
                <ShoppingBag className="h-4 w-4" /> Review basket{count > 0 ? ` (${count})` : ""}
              </button>
              <a
                href={waLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="order-whatsapp"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-[#3D352F] hover:border-[#E28721] text-[#F9F6F0] px-7 py-3.5 text-sm tracking-wide transition-colors"
              >
                <MessageCircle className="h-4 w-4 text-[#25D366]" /> Order on WhatsApp
              </a>
            </div>
          </div>

          <div className="bg-[#26211C] p-8 md:p-14 flex flex-col justify-center gap-7">
            {[
              { icon: Phone, label: "Call or WhatsApp", value: CONTACT.phone, href: `tel:${CONTACT.phoneRaw}`, sub: CONTACT.owner },
              { icon: MapPin, label: "Kitchen", value: CONTACT.city },
            ].map((c, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="flex items-start gap-4"
              >
                <div className="h-11 w-11 shrink-0 rounded-full bg-[#B83A14]/15 flex items-center justify-center">
                  <c.icon className="h-5 w-5 text-[#E28721]" />
                </div>
                <div>
                  <p className="text-[11px] uppercase tracking-[0.2em] text-[#B4A79A]">{c.label}</p>
                  {c.href ? (
                    <a href={c.href} className="font-serif text-xl md:text-2xl text-[#F9F6F0] hover:text-[#E28721] transition-colors">
                      {c.value}
                    </a>
                  ) : (
                    <p className="font-serif text-xl md:text-2xl text-[#F9F6F0]">{c.value}</p>
                  )}
                  {c.sub && <p className="text-[#B4A79A] text-sm mt-0.5">{c.sub}</p>}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
